import { Paper, Button, List, Grid } from '@mui/material'
import React, { Fragment } from 'react'
import { useStyles } from '../styles'
import { PickingMessageView } from '../../../interfaces/Picking/Picking'
import { ListItemWarning } from '../ListItemWarning'

interface PickingMessageProps {
  messageView: PickingMessageView
  handleErrorReturn: any
}

export const PickingMessage: React.FC<PickingMessageProps> = ({
  messageView,
  handleErrorReturn
}) => {
  const classes = useStyles()
  return (
    <Fragment>
      <Paper elevation={1} style={{ padding: '10px' }}>
        <Grid
          container
          direction='column'
          justifyContent='flex-start'
          alignItems='center'
          spacing={2}
        >
          <Grid item xs={12}>
            <List className={classes.alert}>
              <ListItemWarning
                primary={messageView.title}
                secondary={messageView.message}
              />
            </List>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant='contained'
              color='primary'
              onClick={handleErrorReturn}
            >
              Aceptar
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  )
}
